import { useState, useEffect } from 'react';
import axios from '../utils/axios';
import HomeSlider from '../components/home/HomeSlider';
import CategoryGrid from '../components/home/CategoryGrid';
import StorySection from '../components/home/StorySection';
import LatestProductsSection from '../components/home/LatestProductsSection';
import MarqueeBar from '../components/home/MarqueeBar';
import ExperienceSection from '../components/home/ExperienceSection';
import GiftCollectionsSection from '../components/home/GiftCollectionsSection';
import NewsletterSection from '../components/home/NewsletterSection';

let homeCategoriesCache = null;
let homeSettingsCache = null;

const Home = () => {
  const [categories, setCategories] = useState(homeCategoriesCache || []);
  const [settings, setSettings] = useState(homeSettingsCache || null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchHomeData();
  }, []);

  const fetchHomeData = async () => {
    try {
      const [catsRes, settingsRes] = await Promise.all([
        axios.get('/categories'),
        axios.get('/settings')
      ]);
      const cats = catsRes.data.data || [];
      const sets = settingsRes.data;
      homeCategoriesCache = cats;
      homeSettingsCache = sets;
      setCategories(cats);
      setSettings(sets);
    } catch (error) {
      console.error('Veri yükleme hatası:', error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-white">
      {/* 1. Full Screen Hero Slider */}
      <HomeSlider settings={settings} />

      {/* 2. Marquee Promo Bar */}
      <MarqueeBar settings={settings} />

      {/* 3. Category Grid */}
      <CategoryGrid categories={categories} />

      {/* 4. Story Section */}
      <StorySection settings={settings} />

      {/* 5. Latest Products Grid */}
      <LatestProductsSection />

      {/* 6. Experience Section */}
      <ExperienceSection settings={settings} />

      {/* 7. Gift Collections Section */}
      <GiftCollectionsSection settings={settings} />

      {/* 8. Newsletter Section */}
      <NewsletterSection />
    </div>
  );
};

export default Home;
